import { Injectable } from '@angular/core';
import { LoadingController, ToastController } from '@ionic/angular';
@Injectable({
  providedIn: 'root',
})
export class WidgetsService {
  isLoading = false;
  constructor(
    private loadingController: LoadingController,
    private toastController: ToastController
  ) {}
  async toastWithButtons(message = 'Something went wrong', color) {
    const toast = await this.toastController.create({
      animated: true,
      position: 'top',
      buttons: [
        {
          side: 'end',
          icon: 'close',
          handler: () => null,
        },
      ],
      color,
      cssClass: 'toast',
      duration: 2000,
      keyboardClose: true,
      message,
    });
    toast.present();
  }
  async showLoaderWithText(model = 'Leap Motors') {
    this.isLoading = true;
    return await this.loadingController
      .create({
        // mode: 'ios',
        spinner: null,
        // message: 'msg',
        // eslint-disable-next-line max-len
        message: `<ion-img src="assets/img/one3d-api-loader.svg"></ion-img><p class="one3d-loader-bottom-text">${model} will be yours to explore<br>in just a couple of seconds!</p>`,
        cssClass: 'one3d-api-loader-opaque',
      })
      .then((a) => {
        a.present().then(() => {
          if (!this.isLoading) {
            a.dismiss().then(() => {});
          }
        });
      });
  }
  async showLoader(msg = 'Please wait...') {
    this.isLoading = true;
    return await this.loadingController
      .create({
        // mode: 'ios',
        spinner: null,
        // message: 'msg',
        message:
          '<ion-img src="assets/img/one3d-api-loader.svg"></ion-img>',
        cssClass: 'one3d-api-loader',
      })
      .then((a) => {
        a.present().then(() => {
          if (!this.isLoading) {
            a.dismiss().then(() => {});
          }
        });
      });
  }
  async hideLoader() {
    this.isLoading = false;
    this.loadingController
      .getTop()
      .then((v) => (v ? this.doStopLoader() : null));
  }
  doStopLoader() {
    this.loadingController.dismiss();
  }
}
